import React, { useState, useEffect } from "react"
import { Trans } from "@lingui/react"
import OtherIncomeAndExpenses from "./OtherIncomeAndExpenses"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { selectCreatedVslaInfo } from "../../store/reducers/getVslas"
import styles from "./OtherExpenses.module.css"

const OtherExpenses = (props) => {
  const [vsla_id, setVslaId] = useState("")
  const { vslaSummary, currentMember } = useSelector((state) => ({
    vslaSummary: selectCreatedVslaInfo(state),
    currentMember: state.loadedMember,
  }))

  useEffect(() => {
    const { vsla } = vslaSummary[0]
    setVslaId(vsla?.id)
  }, [vslaSummary])

  return (
    <div>
      <div>
        <h4 className={styles.header}>{currentMember?.full_name}</h4>
      </div>
      <h4 className={styles.header}>
        <Trans id="title_copy.otherExpenses">GROUP EXPENSES</Trans>
      </h4>
      <OtherIncomeAndExpenses
        vsla_id={vsla_id}
        amount={props.amount}
        history={props.history}
        sourceFundType={props.destination}
        destination="issuer"
        otherType="Group expenses"
        inputName="sourceFundType"
      />
    </div>
  )
}

OtherExpenses.propTypes = {
  amount: PropTypes.string,
  history: PropTypes.object,
  destination: PropTypes.string,
}

export default OtherExpenses
